import { cn } from "@repo/ui/lib/utils";
import { forwardRef, HTMLAttributes } from "react";
import Icon, { IconName } from "@repo/ui/components/ui/icon/icon";
import { cva, type VariantProps } from "class-variance-authority";

interface ChipProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof chipVariants> {
  icon?: IconName;
}

const chipVariants = cva(
  "content-center whitespace-nowrap rounded-full font-medium text-base max-md:text-xs cursor-pointer flex items-center justify-center ",
  {
    variants: {
      variant: {
        default:
          "border border-primary-black bg-white text-primary-black dark:border-primary-white dark:bg-transparent dark:text-primary-white px-4 py-3 max-md:px-3 max-md:py-3",
        solid: "border-none dark:bg-secondary-gray4 bg-secondary-gray3",
        solidSelected:
          "border-none dark:bg-primary-white bg-primary-black text-primary-white dark:text-primary-magenta",
      },
      size: {
        default: "leading-5",
        slim: "leading-none max-md:leading-none py-2 px-5 max-md:px-4",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Chip = forwardRef<HTMLDivElement, ChipProps>(
  ({ className, icon, variant, size, onClick, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(chipVariants({ variant, size, className }))}
        onClick={onClick}
      >
        {props.children}
        {icon && (
          <Icon
            className={cn(
              "h-[16px] w-[16px] p-[4px] rounded-full bg-primary-black dark:bg-primary-white",
              " right-0 stroke-primary-white fill-primary-white dark:stroke-primary-magenta dark:fill-primary-magenta ml-2 max-md:h-[6px] max-md:w-[6px]",
            )}
            icon={icon}
          ></Icon>
        )}
      </div>
    );
  },
);
Chip.displayName = "Chip";

export default Chip;
